/* eslint-disable no-restricted-imports */
import styled from 'styled-components';
import { Flex, FlexProps } from '../../layout/Flex';
import { Typography, TypographyProps } from '../../typography/Typography';

export const BadgeContainer = styled(Flex)
    .withConfig({ displayName: 'ProductMonetizationContainer' })
    .attrs<FlexProps>((props) => ({
        height: 20,
        width: 'fit-content',
        direction: 'row',
        alignItems: 'center',
        backgroundColor: props.backgroundColor,
        px: 0.5,
        spacing: 0.5,
        borderRadius: 1,
    }))``;

export const CurrencyIcon = styled(Typography)
    .withConfig({ displayName: 'ProductMonetizationCurrencyIcon' })
    .attrs<TypographyProps>((props) => ({
        textAlign: 'center',
        width: props.width ?? 12,
        height: props.height ?? 12,
        borderRadius: 999,
        backgroundColor: props.backgroundColor,
        color: props.color,
        pt: '1px',
        variant: 'caption2',
        weight: 'medium',
    }))``;

export const BadgeLabel = styled(Typography)
    .withConfig({ displayName: 'ProductMonetizationLabel' })
    .attrs<TypographyProps>((props) => ({
        variant: 'caption2',
        color: props.color,
        weight: 'medium',
        noWrap: true,
        textAlign: 'left',
        pt: props.pt,
    }))`
`;
